/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 4/17/20
 * Time: 1:02 AM
 */
import React,{Component} from 'react';
import './GoogleAutoComplete.scss';
import PlacesAutocomplete, {geocodeByAddress, getLatLng} from "react-places-autocomplete";
import './CustomStyles.css';
import { Icon } from 'semantic-ui-react'

class App extends Component{
  state = {
    longitude: '',
    latitude: '',
    address: ''
  };
  handleChange = address => {
      address = address.trim() === "" ? null:address;
    this.setState({address});
  };
  handleSelect = address => {
    this.setState({address});

    geocodeByAddress(address)
      .then(results => getLatLng(results[0]))
      .then(latLng => {

        this.props.setLocation({latitude:latLng.lat,longitude:latLng.lng,address:address,name: this.props.name});
        this.setState({
          longitude: latLng.lng,
          latitude: latLng.lat
        })
      })
      .catch(error => {
        this.setState({
          longitude: 0,
          latitude: 0
        })
      })
      .finally(fin => {
      })
    ;
  };

  render() {
      let {address} = this.state;
      let {location} = this.props;
    return (
      <div className={"google-auto-complete"}>

        <PlacesAutocomplete
          searchOptions={{
            // types: ['(cities)'],
            componentRestrictions: { country: 'lk' },
          }}
          value={address !== "" ? address: location ?  location.address:""}
          onChange={this.handleChange}
          onSelect={this.handleSelect}
          className={"input pac-target-input"}
        >
          {({getInputProps, suggestions, getSuggestionItemProps, loading}) => (
            <div className={"serachBarOfMap"}>
              <input
                icon='search'
                type="text"
                style={{
                  width:'46%'
                }}
                {...getInputProps({
                  placeholder: 'Search Location',
                  className: 'location-search-input input pac-target-input',
                })}
                value={this.state.address}
              />
              <Icon name='search' style={{marginLeft:'5px'}}/>
              {
                suggestions.length !== 0 ?
                  <div className="autocomplete-dropdown-container">
                    {loading && <span/>}
                    {suggestions.map((suggestion, index) => {
                      const className = suggestion.active
                        ? 'suggestion-item--active'
                        : 'suggestion-item';
                      // inline style for demonstration purpose
                      const style = suggestion.active
                        ? {backgroundColor: '#b3d0fa', cursor: 'pointer'}
                        : {backgroundColor: '#ffffff', cursor: 'pointer'};
                      return (
                        <div
                          key = { index }
                          {...getSuggestionItemProps(suggestion, {
                            className,
                            style,
                          })}
                        >
                          <span key = { index } >{suggestion.description}</span>
                        </div>
                      );
                    })}
                  </div>:null
              }
            </div>
          )}
        </PlacesAutocomplete>
      </div>
    );
  }
}
export default App;
